import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import styles from "../../../styles/gri/general.module.css";
import {
  Box,
  Button,
  TextField,
  Typography,
  Alert,
  Snackbar,
} from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, api, get } from "../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";
import SectionHeading from "../GRI300/GRI308/SectionHeading";
import CustomTextField from "../GRI300/GRI308/CustomTextField";

const Economic210 = ({ hide }) => {
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState(false);
  const { id } = useParams();
  const [errors, setErrors] = useState({});
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [formData, setFormData] = useState({
    selectionCriteria: "",
    nominatingAndSelecting: "",
    bodyComposition: "",
  });
  const [griReview, setGriReview] = useState(() =>
    JSON.parse(localStorage.getItem("griReview"))
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(
          `${api}/gri/get?type=GeneralDisclosures2021&Id=${id}`
        );
        const data =
          response.data.data.GeneralDisclosures2021
            ?.nominationSelectionProcesses || {};
        if (response?.data?.data?.year < currentYear - 1) setDisabled(true);
        setFormData({
          selectionCriteria: data.selectionCriteria || "",
          nominatingAndSelecting: data.nominatingAndSelecting || "",
          bodyComposition: data.bodyComposition || "",
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const handleStorage = () => {
      setGriReview(JSON.parse(localStorage.getItem("griReview")));
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const validateForm = () => {
    let newErrors = {};
    let formIsValid = true;

    // Validate sector

    if (!formData.selectionCriteria) {
      newErrors.selectionCriteria = "This field is required";
      formIsValid = false;
    }

    if (!formData.nominatingAndSelecting) {
      newErrors.nominatingAndSelecting = "This field is required";
      formIsValid = false;
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      if (!validateForm()) return; // Validate form before submission

      const payload = {
        type: "GeneralDisclosures2021",
        nominationSelectionProcesses: {
          ...formData,
        },
        submitted2_10: true,
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, payload);
        navigate(`/gri/general-disclosure/2-11/${id}`);
      } catch (error) {
        console.error("Error updating data:", error);
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/general-disclosure/2-11/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      {/* <SectionHeading text="2-1 Activities, value chain and other business relationships" /> */}
      <p className={styles.main_heading}>
        2-10 Nomination and selection of the highest governance body
      </p>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {/* Section A */}
        <SectionHeading
          text="a. Describe the nomination and selection processes for the highest governance body and its committees in the organisation."
          sx={{ marginTop: hide ? "-1rem" : "0rem" }}
        />
        <CustomTextField
          value={formData.selectionCriteria}
          onChange={(e) =>
            handleInputChange("selectionCriteria", e.target.value)
          }
          error={errors.selectionCriteria}
          helperText={errors.selectionCriteria}
          disabled={disabled}
        />

        {/* Section B */}
        <SectionHeading
          text="b. Describe the criteria used for nominating and selecting highest governance
     body members, including whether and how the views of stakeholders (including shareholders), diversity, independence; competencies relevant to the impacts of the organization are taken into consideration."
        />
        <CustomTextField
          value={formData.nominatingAndSelecting}
          onChange={(e) =>
            handleInputChange("nominatingAndSelecting", e.target.value)
          }
          error={errors.nominatingAndSelecting}
          helperText={errors.nominatingAndSelecting}
          disabled={disabled}
        />

        {/* Submit Button */}

        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default Economic210;
